<script setup lang="ts">
import { Loader2 } from 'lucide-vue-next'

defineProps<{
  isLoading?: boolean
  hideText?: boolean
}>()
</script>
<template>
  <span class="h-full flex items-center text-sm">
    <Loader2 class="w-4 h-4 animate-spin mr-1" /> <span v-if="!hideText">Loading...</span>
  </span>
</template>
